import { EquipmentTimeEquipment } from '../model/transfer-time/equipment-time-equipment';
import { Injectable } from '@angular/core';
import { ServiceTimeService } from '../model/transfer-time/service-time-service';
import { CenterTimeCenter } from '../model/transfer-time/center-time-center';
import { ReservationService } from './reservation.service';
import { FilterService } from './filter.service';
import { EquipmentFilter } from '../model/equipment-filter';
import { ReservationSlot } from '../model/reservation-slot';

@Injectable()
export class TransferTimeService {

  equipmentTimeEquipments: EquipmentTimeEquipment[];
  serviceTimeService: ServiceTimeService[];
  centerTimeCenter: CenterTimeCenter[];
  equipments: EquipmentFilter[] = [];

  constructor(private reservationService: ReservationService
              , private filterService: FilterService) {
    this.filterService.getEquipmentsFilter().then((allEquipments) => this.equipments = allEquipments);
    // busco los tiempos de traslado para caluclar despues cuando se seleccione los slots
    this.reservationService.getTransferTime().then((info) => {
      this.equipmentTimeEquipments = info.EquipmentTransfer;
      this.serviceTimeService = info.ServiceTransfer;
      this.centerTimeCenter = info.CenterTransfer;
    });
  }

  public getDateTo(sourceSlot: ReservationSlot, destinationSlot: ReservationSlot): Date {
    let response = new Date(sourceSlot.DateTo); 
    
    // busco el tiempo de traslado entre equipos
    const equipmentTime = this.equipmentTimeEquipments.find(e =>
      e.EquipmentSourceId === sourceSlot.EquipmentId
      && e.EquipmentDestinationId === destinationSlot.EquipmentId);

    if (equipmentTime && equipmentTime.Time > 0) {
      const equTime = new Date(new Date(sourceSlot.DateTo).setMinutes(response.getMinutes() + equipmentTime.Time));
      if (response <  equTime) {
        response = equTime;
      }
    }

    const equipmentSource = this.equipments.find(e => e.Id === sourceSlot.EquipmentId);
    const equipmentDestination = this.equipments.find(e => e.Id === destinationSlot.EquipmentId);

    // si no hay entre equipos, busco por servicio
    const serviceTime = this.serviceTimeService.find(e =>
      e.ServiceSourceId === equipmentSource.ServiceId
      && e.ServiceDestinationId === equipmentDestination.ServiceId);
    
    if (serviceTime && serviceTime.Time > 0) {
      const serviTime = new Date(new Date(sourceSlot.DateTo).setMinutes(response.getMinutes() + serviceTime.Time)); 
      if (response <  serviTime) {
        response = serviTime;
      }
    } 

    const centerTime = this.centerTimeCenter.find(e =>
      e.CenterSourceId === equipmentSource.CenterId
      && e.CenterDestinationId === equipmentDestination.CenterId);

    if (centerTime && centerTime.Time > 0) {
      const centeTime = new Date(new Date(sourceSlot.DateTo).setMinutes(response.getMinutes() + centerTime.Time)); 
      if (response <  centeTime) {
        response = centeTime;
      }
    } 

    return response;
  }
}
